/**
 * This is intended to be a bypass for special cases where React/Redux performance
 * is inadequate. Don't use this unless you have a specific reason to do so.
 *
 * Use with CustomEvent
 */

export const PAGE_AREA = 'events.pageArea';
export const PAGE_EFFECT = 'events.pageEffect';
export const BATCH_SCROLL = 'events.batchScroll';
export const BATCH_SCROLL_UPDATE = 'events.batchScrollUpdate';
export const MODAL_OPENED = 'events.modalOpened';



// WEBPACK FOOTER //
// ./src/app/api/events.js